import { FC } from "react"
import { Wrench } from "lucide-react"
import { useFetchAllBrandsQuery } from "../../../../redux/queries"
import LoTransferAssets from "./lo-transfer-assets"
import LoTransferBrand from "./lo-transfer-brand"
import CalendlyConfig from "./calendly-config"
import WebflowDomainConfig from "./webflow-domain-config"
import SmsFollowupFilters from "./sms-followup-filters"
import BrandSmsSettings from "./brand-sms-settings"
import InvoiceDiagnostic from "./invoice-diagnostic"
import LodestarDiagnostic from "./lodestar-diagnostic"
import AnonymizeEmail from "./anonymize-email"
import AiPromptAmendments from "./ai-prompt-amendments"

const ConfigTools: FC = () => {
  const { data: brands } = useFetchAllBrandsQuery({ limit: 999 })

  return (
    <div>
      <div className="mb-6">
        <div className="flex items-center gap-2 text-gray-700">
          <Wrench className="w-5 h-5" />
          <h2 className="text-lg font-semibold">Admin Tools</h2>
        </div>
        <p className="text-sm text-gray-500 mt-1">
          Utilities for site administrators to manage loan officers and their
          data.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <AiPromptAmendments brands={brands ?? []} />
        <LoTransferAssets brands={brands ?? []} />
        <LoTransferBrand brands={brands ?? []} />
        <CalendlyConfig />
        <WebflowDomainConfig />
        <SmsFollowupFilters brands={brands ?? []} />
        <BrandSmsSettings brands={brands ?? []} />
        <InvoiceDiagnostic />
        <LodestarDiagnostic />
        <AnonymizeEmail />
      </div>
    </div>
  )
}

export default ConfigTools
